export const fileTitles = [{
    name: '0.jpg',
    alt: "Our Sign"
  },
  {
    name: '16.jpg',
    alt: "Team member Helping"
  },
  {
    name: '2.jpg',
    alt: "Kids Study"
  },
  {
    name: '3.jpg',
    alt: 'Giving out food'
  },
  {
    name: '4.jpg',
    alt: 'More food spread'
  },
  {
    name: '5.jpg',
    alt: 'Typical house in slums'
  },
  {
    name: '6.jpg',
    alt: 'Parents with kids'
  },
  {
    name: '7.jpg',
    alt: 'kids huddled up'
  },
  {
    name: "8.jpg",
    alt: 'kids with books'
  },
  {
    name: '9.jpg',
    alt: 'kids in a group'
  },
  {
    name: "10.jpg",
    alt: 'more kids in a group'
  },
  {
    name: '11.jpg',
    alt: 'Poor kids'
  },
  {
    name: '12.jpg',
    alt: 'Kids sitting and drawing'
  },
  {
    name: '13.jpg',
    alt: "Kids in Slums"
  },
  {
    name: '14.jpg',
    alt: "Slum lady volunteer"
  },
  {
    name: '15.jpg',
    alt: "Parents and their kids"
  },
  {
    name: '1.jpg',
    alt: "Our staff with kids"
  },
  {
    name: '17.jpg',
    alt: 'mum looked after'
  }

];



// WEBPACK FOOTER //
// ./src/components/Events/SpecialCamps/Camps-data.js